import requests from "./httpService";

const PlanServices = {

    // Plans
    getAllPlan: async () => {
        return requests.get(`/plans`);
    },
    getPlanById: async (id) => {
        return requests.get(`/plans/${id}`);
    },
    addPlan: async (body) => {
        return requests.post(`/plans`, body);
    },
    updatePlan: async (id, body) => {
        return requests.put(`/plans/${id}`, body);
    },
    deletePlan: async (id) => {
        return requests.delete(`/plans/${id}`);
    },

    // Subscriptions
    subscriptionList: async () => {
        return requests.get(`/subscriptions`);
    },
    getActiveSubscription: async () => {
        return requests.get(`/subscriptions/my`);
    },
    getSubscriptionHistory: async () => {
        return requests.get(`/subscriptions/my/history`);
    },

    // Create Razorpay order (user buys plan)
    createSubscriptionByUser: async (body) => {
        return requests.post(`/subscriptions/order`, body);
    },
    // Verify Razorpay payment
    verifySubscription: async (body) => {
        return requests.post(`/subscriptions/verify`, body);
    },

    // Admin: manual assign
    createSubscriptionList: async (body) => {
        return requests.post(`/subscriptions/assign`, body);
    },
    deleteSubscription: async (id) => {
        return requests.delete(`/subscriptions/my/${id}`);
    },
}

export default PlanServices;
